import Link from "next/link";

const MOCKUPS = [
  { slug: "a", label: "A · Quiet Editorial" },
  { slug: "b", label: "B · Cinema Magazine" },
  { slug: "c", label: "C · Swiss Grid Newsroom" },
  { slug: "d", label: "D · Terminal Live" },
  { slug: "e", label: "E · Conversational AI" },
  { slug: "f", label: "F · Brutalist" },
  { slug: "g", label: "G · Almanac Việt Nam" },
];

type Slug = "a" | "b" | "c" | "d" | "e" | "f" | "g";

export function PreviewBar({ active }: { active: Slug }) {
  return (
    <div
      className="sticky top-0 z-50 border-b"
      style={{
        background: "rgba(15,15,15,0.92)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        color: "#fff",
        borderColor: "rgba(255,255,255,0.1)",
      }}
    >
      <div className="mx-auto max-w-[1400px] px-6 py-3 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <span className="text-[10px] uppercase tracking-[0.25em] font-mono text-white/60">
            Theme preview
          </span>
          <span className="text-[13px] font-semibold">
            Mockup {active.toUpperCase()}
          </span>
        </div>
        <div className="flex items-center gap-2">
          {MOCKUPS.map((m) => (
            <Link
              key={m.slug}
              href={`/admin/theme/preview/${m.slug}`}
              className={`px-3 py-1.5 rounded-full text-[12px] font-medium border transition ${
                active === m.slug
                  ? "bg-white text-black border-white"
                  : "border-white/20 text-white/80 hover:border-white/60 hover:text-white"
              }`}
            >
              {m.label}
            </Link>
          ))}
          <Link
            href="/admin/theme"
            className="px-3 py-1.5 rounded-full text-[12px] font-medium border border-white/20 text-white/80 hover:border-white/60 hover:text-white transition ml-2"
          >
            ← Quay lại
          </Link>
        </div>
      </div>
    </div>
  );
}
